export const ThinChevronIcon = (
	props: React.ComponentPropsWithoutRef<"svg">,
) => {
	return (
		<svg viewBox="0 0 16 10" {...props}>
			<use href="/images/icons.svg#vlw-thin-chevron" />
		</svg>
	)
}
